import React from "react";
import ArrowRightIcon from "@/assets/icons/arrow-right.svg";
import WalletIcon from "@/assets/icons/wallet.svg";
import { Button } from "@/app/(components)/Basic/Button";
import { Nft } from "@/api/nfts/types";

import { useRouter } from "next/navigation";
import useWithCorrectNetwork from "@/shared/hooks/useWithCorrectNetwork";
import { Type } from "@/app/(components)/Basic/Button/constants";

export interface Props {
  nft: Nft;
  disable?: boolean;
  isSaleExpired?: boolean;
}

export default function PutOnSaleButton({
  nft,
  disable,
  isSaleExpired,
}: Props) {
  const router = useRouter();

  const checkedPutForSale = useWithCorrectNetwork(() => {
    router.push(`/for-sale/${nft.id}`);
  });

  return (
    <>
      <Button
        element={Type.Button}
        onClick={checkedPutForSale}
        className="-bottom-20 mt-10 lg:mt-0 lg:absolute"
        startIcon={<WalletIcon />}
        endIcon={<ArrowRightIcon className="w-4" />}
        disabled={disable}
      >
        {nft.isOnSale ? "Edit sale" : "Sell"}
      </Button>
      {isSaleExpired && nft.isOnSale && (
        <span className="text-red text-lg -bottom-[110px] mt-2 lg:mt-0 lg:absolute">
          Sale Expired
        </span>
      )}
    </>
  );
}
